var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagGray1616 = function SvgTagGray1616(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE0E1",
    fillRule: "evenodd",
    d: "m9.557 15.05 5.497-5.498a1.534 1.534 0 0 0 0-2.163L8.46.793A1 1 0 0 0 7.753.5H1.5a1 1 0 0 0-1 1v6.254a1 1 0 0 0 .293.708l6.594 6.588a1.533 1.533 0 0 0 2.17 0M6.112 4.378a1.735 1.735 0 1 1-3.47 0 1.735 1.735 0 0 1 3.47 0",
    clipRule: "evenodd"
  })));
};
export default SvgTagGray1616;